import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { PurchasesService } from "../services/purchases/purchases.service";
import { PurchasedPackModel } from "../../shared/entities/purchased-pack.model";

@Injectable()
export class PurchasedPackModelRepository {
	constructor(private purchasesService: PurchasesService) {}

	public getPurchasedPacks(clientId: any, paginate: boolean = true): Observable<PurchasedPackModel[]> {
		return this.purchasesService.getPurchasesPacks(clientId, paginate).pipe(
			map((result: { data: PurchasedPackModel[] }) => result.data),
			catchError((err) => observableOf(err)),
		);
	}

	public getPurchasedPacksWithFilters(isTrial: boolean, paginate: boolean = true): Observable<any> {
		return this.purchasesService.getPurchasesPacksTrial(isTrial, paginate).pipe(
			map((purchasedPacks: PurchasedPackModel[]) => purchasedPacks),
			catchError((err) => observableOf(err)),
		);
	}

	public getSubscriptionInvoice(purchasedPackId: string) {
		return this.purchasesService.getSubscriptionInvoice(purchasedPackId).pipe(
			map((purchasedPacks: PurchasedPackModel[]) => purchasedPacks),
			catchError((err) => observableOf(err)),
		);
	}

	public updatePurchasedModelById(purchasedPack: PurchasedPackModel, objectToUpdate: any): Observable<PurchasedPackModel | null> {
		return this.purchasesService.patchPurchasedPackModelById(purchasedPack, objectToUpdate).pipe(
			map((data) => {
				const purchasedPackAux: PurchasedPackModel = new PurchasedPackModel().deserialize(data);
				return purchasedPackAux;
			}),
			catchError(() => {
				return observableOf(null);
			}),
		);
	}

	public generateBillById(purchasedPack: PurchasedPackModel): Observable<PurchasedPackModel> {
		return this.purchasesService.generateBillById(purchasedPack).pipe(
			map((data) => {
				const purchasedPackAux: PurchasedPackModel = new PurchasedPackModel().deserialize(data);
				return purchasedPackAux;
			}),
			catchError((data) => {
				return observableOf(data);
			}),
		);
	}

	public checkIfHaveToRenew(purchasedPack: PurchasedPackModel): Observable<PurchasedPackModel> {
		return this.purchasesService.checkIfHaveToRenew(purchasedPack).pipe(
			map((data: any) => {
				return data;
			}),
			catchError((data) => {
				return observableOf(data);
			}),
		);
	}
}
